import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {QUESTION_VALIDATORS} from '../../../../constants/validators';

@Component({
  selector: 'app-position-picker-dialog',
  templateUrl: './position-picker-dialog.component.html',
  styleUrls: ['./position-picker-dialog.component.css']
})
export class PositionPickerDialogComponent implements OnInit {

  positionForm: FormGroup;
  minPosition = 1;
  maxPosition = 1;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<PositionPickerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      min: number,
      max: number,
      current: number,
    },
  ) {
    this.positionForm = this.fb.group({
      position: [this.data.current, QUESTION_VALIDATORS.POSITION],
    });
    this.minPosition = this.data.min;
    this.maxPosition = this.data.max;
  }

  ngOnInit(): void {
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.positionForm.valid) {
      this.dialogRef.close({
        position: this.positionForm.controls.position.value,
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
